


export function getSession(name, defaultvalue) {
    const item = sessionStorage.getItem(name);
    return item ?? defaultvalue;

};

export function setSession(name, value) {
    sessionStorage.setItem(name, value);
};

export function removeItem(name) {
    sessionStorage.removeItem(name);
};

export function clearAll() {
    sessionStorage.clear();
};

export function getSessionJson(name, defaultvalue) {
    // console.log("getSessionJson", name)
    const item = sessionStorage.getItem(name);
    // if (item) {
    //     console.log(item);
    //     console.log(typeof item);
    // }

    return item ? JSON.parse(item) : defaultvalue;

};

export function setSessionJson(name, value) {
    if (value)
        sessionStorage.setItem(name, JSON.stringify(value));
};

export function StringFormat() {
	let args = arguments;

	return args[0].replace(/{(\d+)}/g, function(match, num) {
		num = Number(num) + 1;
		return args[num] != undefined ? args[num] : "";
    });
}

export function ChangeDecomalPoint(value, defaultvalue) {
    let CommisionChange = Math.ceil(value * defaultvalue)/ defaultvalue;
    return CommisionChange ;
}

